import React from 'react'
import { getSkeletonByType, SkeletonType } from 'components/patterns/Skeleton/utils'

interface LoadingProps {
	children?: React.ReactNode
	type?: SkeletonType
}

/**
 * Skeleton shown while something loads
 * @constructor
 */
export const LoadingSkeleton = ({ children, type = SkeletonType.line }: LoadingProps): JSX.Element => {
	if (children) return <>{children}</>
	return getSkeletonByType(type)
}

interface DependentLoadingProps {
	children?: React.ReactNode
	type?: SkeletonType
	dependency: unknown | null | undefined
}

/**
 * Skeleton shown while something other than it's passed children loads
 * @constructor
 */
export const DependentLoadingSkeleton = ({
	children,
	dependency,
	type = SkeletonType.line
}: DependentLoadingProps): JSX.Element => {
	if (dependency) return <>{children}</>
	return getSkeletonByType(type)
}

interface CustomDependentLoadingProps extends DependentLoadingProps {
	customSkeleton: JSX.Element
}

/**
 * Skeleton shown while something other than it's passed children loads
 * @constructor
 */
export const CustomDependentLoadingSkeleton = ({
	children,
	dependency,
	customSkeleton
}: CustomDependentLoadingProps): JSX.Element => {
	if (dependency) return <>{children}</>
	return customSkeleton
}
